import { Toast } from 'mrca-components';
import React, { useState } from 'react';
import { authenticatedFetch } from '../../common/api';
import { FETCH_TEMP_ORDER_API, tempCartToken } from './constants';
import { getShop } from '../../common/pageData';
import { addAttributesToCart, addItemsToCart, clearCart, getValues } from '../utils';
import { defaultToastData } from './data';

export const LargeCartPopUp = () => {
    const currentPageUrl = window.location.href;
    const [hasTempCartTokenInUrl, setHasTempCartTokenInUrl] = useState(currentPageUrl.includes(tempCartToken));
    const [toastData, setToastData] = useState({...defaultToastData, showToast: hasTempCartTokenInUrl})


    const handleCartInitialization = async () => {
        const [cartId, orderId, redirectPath] = getValues(currentPageUrl);
        if (!cartId || !orderId || !redirectPath) {
            console.error("one or more  from cartId, orderId and redirectPath is missing ", {cartId, orderId, redirectPath});
            return;
        };

        const shopUrl = getShop();
        initializeTemporaryCart(shopUrl, orderId, cartId, redirectPath);
        window.history.replaceState({}, '', '/');
    };

    const initializeTemporaryCart = async (shopUrl: string, mrOrderId: string, cartId: string, redirectPath: string) => {
        const apiUrl = `${FETCH_TEMP_ORDER_API}?shopURL=${shopUrl}&mrOrderID=${mrOrderId}&id=${cartId}`;
        const responseData = await authenticatedFetch({ api: apiUrl, method: 'GET' });

        if (!responseData) return;

        // test cases: (and expected output) for formattedCartItems
        //  1) when 'properties' key doesn't exist
        //      { id, quantity };
        //  2) when 'properties' key exists and has a single entry
        //      {
        //          id,
        //          quantity,
        //          properties: { "variable name": "value" }
        //      };
        //  3) when 'properties' key exists and has multiple entries
        //      {
        //          id,
        //          quantity,
        //          properties: {
        //              "variable name1": "value",
        //              "variable name2": "value",
        //          }
        //      };

        const formattedCartItems = responseData.lineItems.map(item => ({
            id: Number(item.variantID),
            quantity: Number(item.quantity),
            // only add properties object if it exists
            ...(item.properties && { properties: item.properties }),
        }));

        await clearCart();
        const data = await addItemsToCart(formattedCartItems);
        await addAttributesToCart(mrOrderId);

        setHasTempCartTokenInUrl(false);
        
        const toastParam = data ? `?toast=${data}` : '';
        window.location.href = `${redirectPath}${toastParam}`;
    };

    if (hasTempCartTokenInUrl) {
        handleCartInitialization()
    }

    return (
      hasTempCartTokenInUrl && (
        <Toast
          showToast={hasTempCartTokenInUrl}
          heading={toastData.heading}
          message={toastData.message}
        />
      )
    )
}